import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { SITE } from '../data/content';
import Logo from './Logo';
import './Footer.css';

export default function Footer() {
  const { t, lang } = useLanguage();
  const year = new Date().getFullYear();

  const links = [
    { href: '#home', label: t.nav.home },
    { href: '#about', label: t.nav.about },
    { href: '#products', label: t.nav.products },
    { href: '#contact', label: t.nav.contact },
  ];

  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <div className="site-footer__brand">
          <a href="#home" className="site-footer__logo">
            <Logo size={36} chip />
            <span>{lang === 'ar' ? 'الهلال الأولى' : 'Alhilal First'}</span>
          </a>
          <p>{t.footer.tagline}</p>
        </div>

        <div className="site-footer__col">
          <h4>{t.footer.quickLinks}</h4>
          <ul>
            {links.map((l) => (
              <li key={l.href}>
                <a href={l.href}>{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="site-footer__col">
          <h4>{t.contact.title}</h4>
          <ul>
            <li>
              <a href={`mailto:${SITE.email}`} dir="ltr">{SITE.email}</a>
            </li>
            {SITE.phones.map((phone, i) => (
              <li key={phone}>
                <a href={`tel:${SITE.phonesHref[i]}`} dir="ltr">{phone}</a>
              </li>
            ))}
            <li>{lang === 'ar' ? SITE.addressAr : SITE.addressEn}</li>
          </ul>
        </div>
      </div>

      <div className="site-footer__bottom">
        <div className="container site-footer__bottom-inner">
          <span>
            © {year} {lang === 'ar' ? 'شركة الهلال الأولى للصناعات البلاستيكية' : 'Alhilal First Company'} — {t.footer.rights}
          </span>
        </div>
      </div>
    </footer>
  );
}
